const Types = {
  CARD: 'card',
  ROW:'row',
  ELEMENT:'element',
  NEW_ELEMENT:'new_element',
  NEW_ROW:'new_row'
};

export default Types;


// WEBPACK FOOTER //
// ./ItemTypes.js